import { render, staticRenderFns } from "./SchedulePage.vue?vue&type=template&id=8bdcd70e&scoped=true"
import script from "./SchedulePage.vue?vue&type=script&lang=js"
export * from "./SchedulePage.vue?vue&type=script&lang=js"
import style0 from "./SchedulePage.vue?vue&type=style&index=0&id=8bdcd70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdcd70e",
  null
  
)

export default component.exports